import api from "../../../service/api";
import ActionTypes from "../../actionTypes";
import API_BOOK from "../../../service/endpoints";

const { GET_ALL_DATA_SUCCESS, GET_ALL_DATA_FAIL } = ActionTypes.REPORTS.FLEET_STATUS_HISTORY;
const { GET_HISTORY } = API_BOOK.REPORTS.FLEET_STATUS;

const getSuccessAD = (payload) => ({
  type: GET_ALL_DATA_SUCCESS,
  payload,
});

const getFailAD = () => ({
  type: GET_ALL_DATA_FAIL,
});

export const GetFleetStatusHistory = ({ fromDate, toDate }) => async (dispatch) => {
  try {
    const resp = await api({
      method: GET_HISTORY.method,
      url: GET_HISTORY.url,
      data: { fromDate, toDate }
    });

    if (resp.status === 200 && resp?.data?.data) {
      dispatch(getSuccessAD(resp.data.data));
    } else {
      dispatch(getFailAD());
    }
  } catch (error) {
    dispatch(getFailAD());
    console.log("error:", error);
  }
};
